import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color?: Color;
};

const ToastCloseIcon: FC<Props> = ({ className = '', color = 'white' }) => (
  <Svg width="12px" height="12px" viewBox="0 0 12 12" className={className}>
    <desc>Close Icon.</desc>
    <path
      d="M0.998431 1.50002L10.7891 11.2906"
      stroke={Theme.colors[color]}
      strokeWidth="2"
    />
    <path
      d="M10.7891 1.5L0.998433 11.2906"
      stroke={Theme.colors[color]}
      strokeWidth="2"
    />
  </Svg>
);

export default ToastCloseIcon;
